import './BeneficiariesModal.scss';
import React, {Fragment, useContext, useEffect, useState} from 'react';
import { AAMBeaconButton, AAMBeaconModal } from 'components/shared/Beacon';
import { PageContext } from './StepProvider';
import { connect } from 'react-redux';
import { isEmpty, isNull } from "lodash";
import {
  pushNewBeneficiary,
  resetBeneficiariesContext,
  updateBeneficiary
} from 'state/beneficiaries/BeneficiaryActions';
import Store from 'state/Store';
import { beneficiariesConfig, beneSteps } from './Utils';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import BeneficiaryContext from "./BeneficiaryContext";
import BeneficiariesDetailsList from "./BeneficiariesDetailsList";
import {
  buildBusinessEvent,
  isDeleteAllBeneficiaries,
  BENEFICIARY_EVENT_TYPES
} from 'services/Beneficiary';
import {
  getManageBeneficiaries,
  getPreviousManageBeneficiaries

} from 'state/beneficiaries/BeneficiarySelectors';
import {
  getCustomer,
  getPrimaryEmailAddress
} from 'state/customer/CustomerSelectors';
import {
  addBeneficiaries,
  updateBeneficiaries,
  deleteBeneficiaries,
  captureBeneficiaryBusinessEvent
} from 'services/Rest';
import { handleFormSubmit } from 'components/shared/FormValidation/FormValidation';
import {
  BeneV2FieldValidation,
  capitalizeBeneficiaryNames,
  generateBeneficiaryPayloadV2,
  generateBenficiaryUpdatePayloadV2,
  isSpouseSelected,
  validateTotalDistribution
} from 'services/BeneficiaryV2';
import BeaconNotification from 'components/shared/BeaconNotification/BeaconNotification';
import LeaveBeneConfirmation from './ModalSteps/LeaveBeneConfirmation';

export const closeBeneficiariesModal = (id, resetPageContext) => {
  // remove this to fixed the onclose issue
  // const modal = document.getElementById(id);
  // if (modal) {
  //   modal.close();
  // }
  Store.dispatch(resetBeneficiariesContext());
  resetPageContext();
};

const BeneficiariesUserFlow = ({ customerEmail, customer, currentBeneficiaries, previousBeneficiaries }) => {
  const [confirmationModal, setConfirmationModal] = useState(false);
  const { currPage, goBack, goToPage, goNext, resetPageContext } = useContext(PageContext);
  const [showSpinner, setShowSpinner] = useState(false); 
  const {
    setAddBeneficiaries,
    setAddTODBeneficiaries,
    setManageBeneficiaries,
    formRef,
    updatedBeneficiary,
    agreementsForBeneUpdate,
    addBeneficiariesModal,
    addTODBeneficiariesModal,
    selectedBeneficiaryId,
    setSelectedBeneficiaryId,
    setDeletedBeneficiary,
    setIsEdited,
    setIsAdded,
    setIncludeDistributionValidation,
    agreementsGroupedByRegistrationKey,
    registrationKeyForMismatchUpdate,
    beneficiaries,
    isMismatch,
    invalidField,
    setInvalidField,
    setIsinvalidDelete,
    isCustomerWebView,
    isEsa,
    recentBeneficiary,
    setRecentBeneficiary,
    enableErrorMessage,
    beneficiaryDataIsComplete
  } = useContext(BeneficiaryContext);

  const { primary, secondary, primaryTotalAllocation, secondaryTotalAllocation } = beneficiaries;

  useEffect(() => {
    if (addBeneficiariesModal) {
      goToPage(beneSteps.BENE_ADD_STEP);
    }
    else if(addTODBeneficiariesModal){
      goToPage(beneSteps.BENE_TOD_STEP);
    } else {
      goToPage(beneSteps.BENE_MANAGE_STEP);
    }
  }, []);

  useEffect(() => {
    const scrollToTop = () => {
      const targetElement = document.getElementById('modal-header');
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    };
    scrollToTop();
  }, [currPage]);

  const config = beneficiariesConfig(goToPage, beneficiaries, isCustomerWebView, setSelectedBeneficiaryId,goBack);

  const handleBackClick = () => {
    setIsAdded(false);
    setIsEdited(false);
    if (currPage === beneSteps.BENE_ALLOCATION_STEP) {
      setIncludeDistributionValidation(false);
      setInvalidField([]);
      setIsinvalidDelete(false);
      goBack();
    } else if(currPage === beneSteps.BENE_DETAILS_STEP){
      setSelectedBeneficiaryId(recentBeneficiary._id);
      goToPage(beneSteps.BENE_EDIT_STEP);
    } else{
      setIsinvalidDelete(false);
      setInvalidField([]);
      goBack();
    }
  };

  const handleClose = () => {
    closeBeneficiariesModal('beneficiaries_new_user_V2_modal_V2', resetPageContext);
    setAddBeneficiaries(false);
    setManageBeneficiaries(false);
    setDeletedBeneficiary({});
    setInvalidField([]);
    setIsinvalidDelete(false);
    setAddTODBeneficiaries(false);
    const targetElement = document.getElementById('beneficiaries-container-v2');
    if (targetElement) {
        targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const handleConfirmationClose = () => { 
    setConfirmationModal(true) 
  }

  if (currPage < 1) {
    return null;
  }

  const stepProvider = () => {
    if (currPage === beneSteps.BENE_ADD_STEP || currPage === beneSteps.BENE_EDIT_STEP || currPage === beneSteps.BENE_ALLOCATION_STEP) {
      return (
        <>
          <div className="b-grid b-padding-block-end--macro--jumbo beacon-on-lighter">
            {description}
            {invalidField.length > 0 && (
              <BeaconNotification
                title={`There ${invalidField.length === 1 ? 'is' : 'are'} ${invalidField.length
                  } ${invalidField.length === 1 ? 'error' : 'errors'
                  } in the form:`}
                description={
                  <span>
                    {invalidField.map((field, index) => {
                      const key = Object.keys(field)[0];
                      return (
                        <div key={index}>
                          {index + 1}. {field[key]}
                        </div>
                      );
                    })}
                  </span>
                }
                variant="error"

              />
            )}
            {component}
          </div>
        </>
      );
    } else {
      return (
        <>
          {component}
        </>
      );
    }
  }

  const { component, previous, next, additionalActionButton, close, scale, description} = config[currPage];

  const handleSubmit = (event) => {
    const capitalizedUpdatedBeneficiary = capitalizeBeneficiaryNames(updatedBeneficiary);
    const isPrimaryDistributionError = primary.length > 0 && validateTotalDistribution(primaryTotalAllocation);
    const isSecondaryDistributionError = secondary.length > 0 && validateTotalDistribution(secondaryTotalAllocation);
    let benesToEvaluateForSpouse = primary.concat(secondary);
    if (!isNull(selectedBeneficiaryId)) {
      benesToEvaluateForSpouse = benesToEvaluateForSpouse.filter(bene => bene._id !== selectedBeneficiaryId);
    }
    benesToEvaluateForSpouse.push(capitalizedUpdatedBeneficiary);
    const hasSpouseError = isSpouseSelected(benesToEvaluateForSpouse);
    let invalid = [];
    event.preventDefault();
    if (formRef.current && enableErrorMessage) {
      invalid = handleFormSubmit(
        formRef.current,
        BeneV2FieldValidation,
        isPrimaryDistributionError,
        isSecondaryDistributionError,
        hasSpouseError,
        isEsa,
        (value) => { setInvalidField(value) }
      );
    }
    if (currPage === beneSteps.BENE_MANAGE_STEP) {
      if (beneficiaryDataIsComplete) {
        const {primary, secondary} = beneficiaries;
        const isManageStepZero = primary.length === 0 && secondary.length === 0;
        if (isManageStepZero) {
          goToPage(beneSteps.DELETE_BENE_CONFIRMATION_STEP);
        } else {
          goToPage(beneSteps.BENE_ALLOCATION_STEP);
        }
        setDeletedBeneficiary({});
      }
    }
    else if (currPage === beneSteps.BENE_DETAILS_STEP) {
      if(beneficiaryDataIsComplete) {
        goNext();
      }
    }
    else if (currPage === beneSteps.BENE_ADD_STEP) {
      if (formRef.current.checkValidity() && invalid.length === 0) {
        Store.dispatch(pushNewBeneficiary(capitalizedUpdatedBeneficiary));
        setRecentBeneficiary(capitalizedUpdatedBeneficiary);
        goToPage(beneSteps.BENE_DETAILS_STEP);
      }
      setIsEdited(false);
      setIsAdded(true);
    } else if (currPage === beneSteps.BENE_EDIT_STEP) {
      if (formRef.current.checkValidity() && invalid.length === 0) {
        Store.dispatch(updateBeneficiary(selectedBeneficiaryId, capitalizedUpdatedBeneficiary));
        setRecentBeneficiary(capitalizedUpdatedBeneficiary);
        goToPage(beneSteps.BENE_DETAILS_STEP);
      }
      setIsEdited(true);
      setIsAdded(false);
    } else if (currPage === beneSteps.BENE_ALLOCATION_STEP) {
      if (formRef.current.checkValidity() && invalid.length === 0) {
        handleBeneSaveAndSubmit();
      }
    }
    else if (currPage === beneSteps.DELETE_BENE_CONFIRMATION_STEP) {
      handleBeneSaveAndSubmit();
    }
    else {
      goNext();
    }
  };

  const handleBeneSaveAndSubmit = () => {
    let benesPayload;
    setShowSpinner(true);
    //Call post service to add beneficiaries if no previous beneficiaries
    if (isEmpty(previousBeneficiaries) && !isMismatch) {
      benesPayload = generateBeneficiaryPayloadV2(agreementsForBeneUpdate, previousBeneficiaries, currentBeneficiaries);
      const event = buildBusinessEvent(
        BENEFICIARY_EVENT_TYPES.ADD,
        customerEmail,
        customer,
        agreementsForBeneUpdate
      );
      addBeneficiaries(benesPayload, () => {
        captureBeneficiaryBusinessEvent(event);
        handleClose();
        setShowSpinner(false);
      }, () => {
        handleClose();
        setShowSpinner(false);
      });
    }
    // call delete service if previous beneficiaries are empty and delete all beneficiaries
    else if (isEmpty(currentBeneficiaries) || isDeleteAllBeneficiaries(currentBeneficiaries)) {
      benesPayload = generateBeneficiaryPayloadV2(agreementsForBeneUpdate, previousBeneficiaries, currentBeneficiaries);
      const event = buildBusinessEvent(
        BENEFICIARY_EVENT_TYPES.DELETE,
        customerEmail,
        customer,
        agreementsForBeneUpdate
      );
      deleteBeneficiaries(benesPayload, () => {
        captureBeneficiaryBusinessEvent(event);
        handleClose();
        setShowSpinner(false);
      }, () => {
        handleClose();
        setShowSpinner(false);
      });
    }
    //call update(PUT) service if previous beneficiaries are not empty and current beneficiaries are not empty
    else {
      const accounts = isMismatch ? agreementsGroupedByRegistrationKey[registrationKeyForMismatchUpdate] : agreementsForBeneUpdate;
      benesPayload = generateBenficiaryUpdatePayloadV2(accounts, currentBeneficiaries);
      const event = buildBusinessEvent(
        BENEFICIARY_EVENT_TYPES.UPDATE,
        customerEmail,
        customer,
        accounts
      );
      updateBeneficiaries(benesPayload, () => {
        captureBeneficiaryBusinessEvent(event);
        handleClose();
        setShowSpinner(false);
      }, () => {
        handleClose();
        setShowSpinner(false);
      });
    }
  }
  const getActionZoneClassName = (currPage, previous) => {
    switch (currPage) {
      case beneSteps.BENE_ADD_STEP:
        return previous ? "action-zone-align-space-between-row" : "action-zone-align-right-row";
      case beneSteps.BENE_MANAGE_STEP:
        return "action-zone-align-right";
      case beneSteps.BENE_EDIT_STEP:
      case beneSteps.BENE_ALLOCATION_STEP:
        return "action-zone-align-space-between-row";
      case beneSteps.BENE_DETAILS_STEP:
        return "action-zone-align-space-above";
      default:
        return "action-zone-align-space-between";
    }
  };

  return (
    <Fragment>
      <form onSubmit={handleSubmit} className="beneficiaries-form" noValidate ref={formRef}>
        {confirmationModal &&
            <LeaveBeneConfirmation
                open={confirmationModal}
                onClose={handleClose}
                continueEditing={() => setConfirmationModal(false)} />}
        <AAMBeaconModal
          open={true}
          scale={scale}
          id="beneficiaries_new_user_V2_modal_V2"
          className="beneficiaries_new_user_V2_modal"
          persist
          closeOnClickOut={false}
          onBeaconEventClose={handleConfirmationClose}>
          {stepProvider()}
          {currPage === beneSteps.BENE_DETAILS_STEP && (
            <div slot="additional-content" className="b-padding-block-end--macro--jumbo">
              <div className="beneficiaries-modal-additional-content">
                <BeneficiariesDetailsList />
              </div>
            </div>
          )}
          <div slot="action-zone" className={getActionZoneClassName(currPage, previous)}>
            {previous && (
              <div className="left">
                <AAMBeaconButton
                  variant={'tertiary'}
                  onBeaconEventClick={previous.handler ? previous.handler : handleBackClick}
                  className="back-beacon-button">
                  {previous.label}
                  {previous.icon}
                </AAMBeaconButton>
              </div>
            )}
            {close && (
              <div className="cancel">
                <AAMBeaconButton
                  variant={'tertiary'}
                  onBeaconEventClick={handleConfirmationClose}
                  className="close-beacon-button">
                  {close.label}
                  {close.icon}
                </AAMBeaconButton>
              </div>
            )}
            {additionalActionButton && next && (
              <div className="right">
                <AAMBeaconButton
                  variant='secondary'
                  onBeaconEventClick={additionalActionButton.handler}>
                  {additionalActionButton.label}
                  {additionalActionButton.icon}
                </AAMBeaconButton>
                <AAMBeaconButton
                  type="submit"
                  variant={'primary'}
                  className="continue-beacon-button"
                  disabled={next.disabled} >
                  {next.label}
                  {next.icon}
                </AAMBeaconButton>
              </div>
            )}
            {showSpinner ? <div className='right-spinner'> <Spinner /> </div> : next && !additionalActionButton && (
              <div className="right">
                <AAMBeaconButton
                  type="submit"
                  variant={'primary'}
                  className="continue-beacon-button"
                  onBeaconEventClick={next.handler}
                  disabled={next.disabled}>
                  {next.label}
                  {next.icon}
                </AAMBeaconButton>
              </div>
            )}
          </div>
        </AAMBeaconModal>
      </form>
    </Fragment >
  );
};
const mapStateToProps = (state) => ({
  customerEmail: getPrimaryEmailAddress(state).address || '',
  customer: getCustomer(state),
  currentBeneficiaries: getManageBeneficiaries(state),
  previousBeneficiaries: getPreviousManageBeneficiaries(state)
});
export default connect(mapStateToProps)(BeneficiariesUserFlow);
